package com.esoris.kmpmoout.features.expense.expense_form

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Button
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.material3.TopAppBar
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.tooling.preview.Preview
import com.esoris.esocomponent.ui.common.EsoButton
import com.esoris.esocomponent.ui.common.EsoForm
import com.esoris.esocomponent.ui.common.EsoTextField
import com.esoris.esocomponent.ui.common.EsoTextFieldPrice
import com.esoris.kmpmoout.core.appdefaultvalue.AppDefault

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun ExpenseFormScreenContent(
    state: ExpenseFormUiState,
    onEvent: (ExpenseFormEvent) -> Unit,
) {

    Scaffold(
        topBar = {
            TopAppBar(
                title = { Text(text = "New Expense") }
            )
        }
    ){

        Box(
            modifier = Modifier
                .padding(it)
                .fillMaxSize()
        ){

            EsoForm(
                submitButton = {
                    Button(
                        onClick = {
                            onEvent(
                                ExpenseFormEvent.OnSaveNewExpense(
                                    state.expenseForm
                                )
                            )
                        },
                        modifier = Modifier.fillMaxWidth()
                    ){
                        Text(text = "Save")
                    }
                }
            ) {
                Column(
                    verticalArrangement = AppDefault.verticalArrangment
                ) {

                    EsoTextField(
                        value = state.expenseForm.category,
                        onValueChange = {
                            onEvent(
                                ExpenseFormEvent.OnExpenseFormChange(
                                    state.expenseForm.copy(
                                        category = it
                                    )
                                )
                            )
                        },
                        label = "Category",
                        errorMessage = state.expenseForm.categoryError
                    )

                    EsoTextFieldPrice(
                        value = if(state.expenseForm.amount == 0L) "" else state.expenseForm.amount.toString(),
                        onValueChange = {
                            onEvent(
                                ExpenseFormEvent.OnExpenseFormChange(
                                    state.expenseForm.copy(
                                        amount = it.toLongOrNull() ?: 0L
                                    )
                                )
                            )
                        },
                        label = "Amount",
                        errorMessage = state.expenseForm.amountError
                    )

                    EsoTextField(
                        value = state.expenseForm.note,
                        onValueChange = {
                            onEvent(
                                ExpenseFormEvent.OnExpenseFormChange(
                                    state.expenseForm.copy(
                                        note = it
                                    )
                                )
                            )
                        },
                        label = "Note",
                        errorMessage = state.expenseForm.noteError
                    )

                }

            }

        }

    }

}

@Preview(showBackground = true)
@Composable
fun ExpenseFormScreenContentPreview() {
    ExpenseFormScreenContent(
        state = ExpenseFormUiState(),
        onEvent = {}
    )
}